import { Component, OnInit, Input, AfterViewChecked, Output } from '@angular/core';
import { Alert, AlertType } from 'app/model/shared/alert';

import * as $ from 'jquery';
import { Subject } from 'rxjs/Rx';

@Component({
  selector: 'app-agent-popup-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit, AfterViewChecked {

  @Input('show') show: boolean;
  @Input('data') data: Alert;
  @Output('outdata') outdata: string;

  showChanged: Subject<boolean> = new Subject<boolean>();

  AlertType = AlertType;

  constructor(
  ) {
    this.showChanged.subscribe((isShow) => {
      this.show = isShow;
    });
  }

  ngOnInit() {
    this.outdata = '';
  }

  dismissPopup() {
    this.show = false;
    this.ngOnInit();
  }

  OKPopup() {
    if (this.cbContainer) {
      this.cbContainer.yesFn();
    }
    this.dismissPopup();
  }

  ngAfterViewChecked() {
    if (this.show) {
      $('.agent-conatiner #popup-alert button').filter(function() {
        return $(this).text() === 'OK';
      }).focus();
    }
  }

  cbContainer: any;
  confirm(cbObj) {
    cbObj.getContainer().subscribe(container => {
      this.cbContainer = container;
    })
  }

  confirmOnPopup(result: boolean) {
    let dismiss = true;
    if (result) {
      if (this.outdata) {
        this.cbContainer.setData(this.outdata);
      }
      dismiss = this.cbContainer.yesFn();
    } else {
      dismiss = this.cbContainer.noFn();
    }
    if (dismiss == undefined || dismiss == null) {
      dismiss = true;
    }
    if (dismiss === true) {
      this.dismissPopup();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/agent/alert/alert.component.ts